import "core-js/modules/es.array.concat.js";
import { useFetchInitialProps } from '@applyboard/ab-common';
function useGradingSchemesApi(countryCode, educationLevel) {
  var _useFetchInitialProps = useFetchInitialProps("/api/grades/grading_schemes?country_code=".concat(countryCode, "&level=").concat(educationLevel)),
    props = _useFetchInitialProps.props;
  return props;
}
export default useGradingSchemesApi;